import { render } from "./PantryFoodSearchView.vue?vue&type=template&id=3d63d9ae&ts=true"
import script from "./PantryFoodSearchView.vue?vue&type=script&lang=ts"
export * from "./PantryFoodSearchView.vue?vue&type=script&lang=ts"

import "./PantryFoodSearchView.vue?vue&type=style&index=0&id=3d63d9ae&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__